// @flow weak

/* eslint no-console:0 */
import React, {
    Component
  }                     from 'react';
  import PropTypes      from 'prop-types';
  import {
    AnimatedView,
    Panel,
    Breadcrumb,
    Stat,
    ProgressBar,
    ToolTip,
    Pagination,
    Pager,
    TabPanel,
    TabPanelHeader,
    TabPanelBody,
    TabPanelBodyContent,
    Alert,
    Button,
    Label
  }                     from '../../../components';
  import divimg from '../../../img/maintenance.png';
  
  class Maintenance extends Component {
    constructor(props, context){
        super(props, context);
        this.state = {
          backgroundStyles: {}
        };
      
      }

      componentDidMount(){
        this.setState({
            backgroundStyles: {
              'backgroundColor': "black",
              'backgroundPosition': 'center',
            }
          });
      }
      
    render() {
        return(
          <div className="maintenance-container">
              <div className="maintenance" style={{alignContent:"center", color:"white"}}>
              <img src={divimg}></img>
              This site is currently down for maintenance!
              </div>
          </div>
        );
    }
  }
  
  export default Maintenance;
  


// WEBPACK FOOTER //
// ./src/app/views/frontend/maintenance/Maintenance.js